import { Table } from '@nimbus-ds/components';
import { CustomHeaderCell, useResponsive } from 'commons/components';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import { HIDE_NOTIFICATIONS_BREAKPOINT } from '../UsersListDesktopRow/UsersListDesktopRow';

function UsersListDesktopHeader() {
  const t = useTranslationConfigurations('usersListPage.table');
  const { isMobile } = useResponsive(HIDE_NOTIFICATIONS_BREAKPOINT);

  return (
    <Table.Head>
      <CustomHeaderCell width="144px" color="neutral-textHigh">
        {t('name')}
      </CustomHeaderCell>
      <CustomHeaderCell
        width={{ md: '140px', lg: '180px', xl: '220px' }}
        color="neutral-textHigh"
      >
        {t('email')}
      </CustomHeaderCell>
      <CustomHeaderCell width="auto" color="neutral-textHigh">
        {t('permissions')}
      </CustomHeaderCell>
      {!isMobile && (
        <CustomHeaderCell width="auto" color="neutral-textHigh">
          {t('notifications')}
        </CustomHeaderCell>
      )}
      <CustomHeaderCell width="auto" color="neutral-textHigh">
        {t('2fa')}
      </CustomHeaderCell>
      <CustomHeaderCell width="88px" color="neutral-textHigh">
        {t('actions')}
      </CustomHeaderCell>
    </Table.Head>
  );
}

export default UsersListDesktopHeader;
